import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FeatherIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M6.00001 6.99814C6.00001 6.99814 5.40001 6.39814 7.00001 3.99814C8.54865 1.67518 12.7204 1.03851 14.8002 1.00003C14.9106 0.997995 15 1.08764 15.0056 1.19795C15.0118 1.32165 15.0227 1.45252 15.0342 1.59132C15.1153 2.5721 15.2293 3.94931 14.0001 5.99814C12.6368 8.02133 10.1022 8.95926 9.97406 9.00667C9.97071 9.00791 9.96901 9.00857 9.96901 9.00857L10.0001 8.99814C12.213 8.26049 13.0656 9.15523 13.5614 9.67546C13.7377 9.86049 13.8689 9.99814 14.0001 9.99814C11.3625 11.5496 8.46841 12.4462 6 11C6.30981 10.1812 9.5 6 12 3.99814C8.5 5 6 8.49814 5 9.99814C3.34806 7.97231 4.45842 4.03505 5.5 3C5.57274 2.92772 5.67565 3.00872 5.64272 3.10584C5.28548 4.15923 5 7 6.00001 6.99814Z"
		/>
		<path
			fill="currentColor"
			d="M1 14.9981H2L5.5 11.9981L5.13246 11.8144C4.71356 11.6049 4.33117 11.3293 4 10.9981L1 14.9981Z"
		/>
	</svg>
))
